import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ALL_STATUS_FILTER_KEYS } from './statusFilter.constants';
import { ApprovalStatus, StatesFilter } from './types';

const VALID_KEYS = new Set<string>(ALL_STATUS_FILTER_KEYS);

const useStatesQueryParams = () => {
    const [searchParams] = useSearchParams();

    return useMemo(() => {
        const raw = searchParams.get('approval_status');

        // Sanitize present values against the valid key set (drops the retired
        // QUALIFIED + any unknown key). When the param is absent — or contains
        // only stale/invalid keys — no stage filter is applied, so all form
        // fills are shown by default until the user selects stages.
        const cleaned = raw !== null ? raw.split(',').filter((v) => v && VALID_KEYS.has(v)) : [];

        const preparedApprovalStates: StatesFilter[] = cleaned.map((approval_status) => ({
            approval_status: approval_status as ApprovalStatus
        }));

        return preparedApprovalStates;
    }, [searchParams]);
};

export default useStatesQueryParams;
